var React = require('react');

function CheckMarkIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.74634 7.75587C4.07185 8.08138 4.59767 8.08138 4.92318 7.75587L11.2497 1.42097C11.5752 1.09546 11.5752 0.56964 11.2497 0.244131C10.9242 -0.0813771 10.3984 -0.0813771 10.0729 0.244131L4.33059 5.98644L1.92683 3.58268C1.60132 3.25717 1.0755 3.25717 0.749991 3.58268C0.424482 3.90819 0.424482 4.43401 0.749991 4.75952L3.74634 7.75587Z","fill":"white"}));
}

CheckMarkIcon.defaultProps = {"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none"};

module.exports = CheckMarkIcon;

CheckMarkIcon.default = CheckMarkIcon;
